import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type SupportedImageTypes = 'avif' | 'webp' | 'jpg';
export interface BannerImageConfig {
  avif?: {
    desktop: string;
    mobile: string;
  };
  webp?: {
    desktop: string;
    mobile: string;
  };
  jpg: {
    desktop: string;
    mobile: string;
  };
}

@Component({
  selector: 'rd-banner-image',
  templateUrl: './banner-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BannerImageComponent {
  @Input() bannerImageConfig: BannerImageConfig;
  @Input() customPictureClasses: string;
  @Input() customImageClasses: string;

  pictureClasses: string;
  imageClasses: string;

  ngOnInit(): void {
    this.pictureClasses =
      this.customPictureClasses ||
      'absolute top-0 bottom-0 left-0 right-0 -z-10';

    this.imageClasses =
      this.customImageClasses || 'object-cover object-center w-full h-full';
  }
}
